import { sanitizeNationalNumber } from '../../../logic/sanitizeNationalNumber';

export const formatPhoneNumber = (rawValue: string, format: string): string => {
  const digits = sanitizeNationalNumber(rawValue);
  if (!digits) {
    return '';
  }

  let formatted = '';
  let digitIndex = 0;

  for (let i = 0; i < format.length && digitIndex < digits.length; i += 1) {
    const formatChar = format[i];
    if (formatChar === '#') {
      formatted += digits[digitIndex];
      digitIndex += 1;
    } else if (digitIndex > 0) {
      formatted += formatChar;
    }
  }

  if (digitIndex < digits.length) {
    formatted += digits.slice(digitIndex);
  }

  return formatted;
};
